<template>
  <section class="flex level-1" v-touch:swipe.right="swipeRightHandler">   
    
    <!-- //TITLE MOBILE -->
      <div class="mobile"  :class="{isMobile:isMobile}">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
            <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h2>Boutique cadeau</h2>
        </div>
        <div class="sep"></div>
      </div>
    <!-- //TITLE MOBILE -->

    <!-- CONTENT-->
    <div class="block__shop content__shop"> 
      <!-- PART MIDDLE -->
      <div class="column-middle">
        <div class="header entete desktop">
          <PuSkeleton :loading="isLoading" :count="1" width='140px'>                          
            <p>Boutique cadeau</p>
          </PuSkeleton>
        </div>


        <section class="wrapper">
          <PuSkeleton :loading="isLoading" :count="1" height='240px'>                          
            <b-img :src="content.src" class="" fluid alt="placeholder"></b-img>
          </PuSkeleton>
          <a href="" target="_self" class="btn bt btn-browse btn-secondary auto"> 
            <span>
              <font-awesome-icon :icon="['far', 'bags-shopping']" />
            </span>
            Accéder à la boutique cadeau
          </a>
          <PuSkeleton :loading="isLoading" :count="10">
            <div class="content_desc" v-html="content.content">
            </div>
          </PuSkeleton>
        </section>


      </div>
      <!-- PART MIDDLE -->
      <!-- PART RIGHT -->
      <div class="col-right desktop column-right borderLeft">
        <cardPoint points="250" />
      </div>
      <!-- PART RIGHT -->
    </div>
    <!-- CONTENT-->
    
  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import cardPoint from '../../../module/card/CardPoint'
import utils from '../../../Utils'

export default {
  name:"challengeBoutique",
    components:{ 
      cardPoint,
      // SidebarChallenges 
    }, 
    computed: {
      ...mapGetters([
        'getBoutique',
      ])
    },
    data () {
      return {
        content:"",
        isLoading:true,
        isMobile:false,
      }
    },
    created (){
      this.content = this.getBoutique;
      this.isMobile = utils.isMobile();
      setTimeout(() => {
        this.isLoading = false;
        // this.majData();
      },2000);         
    },    
    methods : {   
      goBack() {
        this.$store.dispatch('goBack')
        this.$router.push({name: "challengesHome"});  
      },  
      swipeRightHandler () {
          this.goBack();
      },                   
    }
};
</script>
